export function isAiCapabilityEnabled(appCapabilities = null) {
	return !!appCapabilities && !!appCapabilities.ai && appCapabilities.ai.enabled === true;
}

export function assertAiCapabilityEnabled(appCapabilities = null) {
	if (!isAiCapabilityEnabled(appCapabilities)) {
		throw new Error("AI is not available in this environment.");
	}
}

function getErrorMessage(error) {
	if (error && typeof error.message === "string" && error.message !== "") {
		return error.message;
	}

	return `${error || "Unknown error"}`;
}

export async function initializeAiShares({
	appCapabilities,
	refreshShares,
	clearShares,
	warn = console.warn
} = {}) {
	const clear = typeof clearShares === "function" ? clearShares : () => {};

	if (!isAiCapabilityEnabled(appCapabilities)) {
		clear();
		return { status: "disabled" };
	}

	try {
		await refreshShares();
		return { status: "ready" };
	} catch (error) {
		clear();
		if (typeof warn === "function") {
			warn(`AI share initialization is unavailable; continuing without it. Reason: ${getErrorMessage(error)}`);
		}
		return { status: "unavailable" };
	}
}
